import { useGlobalStore } from "@/stores/globalStore";
import useMerchApiEndpoints from "@/composables/api/useMerchApiEndpoints";
import useTheme from "@/composables/ui/useTheme";
import useMiddleware from "@/router/useMiddleware";
import { useNotificationStore } from "../../stores/components/notificationStore";

export default () => {
  const globalStore = useGlobalStore();
  const notificationStore = useNotificationStore();
  const { handleMerchantAllowDirectVisitFlow } = useMiddleware();
  const { getMerchSettings, getNotificationSettings } = useMerchApiEndpoints();

  const getMerchantSettings = async () => {
    const { updateThemeFromMerchant } = useTheme();
    let settings = await getMerchSettings();
    settings = settings.data;
    globalStore.setMerchantSettings(settings);
    updateThemeFromMerchant(settings.theme);
    handleMerchantAllowDirectVisitFlow(settings);
  };

  const getNotifications = async () => {
    const {
      data: { order, orderStatus },
    } = await getNotificationSettings();
    notificationStore.setBanner(order, orderStatus);
  };

  return {
    getMerchantSettings,
    getNotifications,
  };
};
